import { render, staticRenderFns } from "./addOrEdit.vue?vue&type=template&id=f77caff6&scoped=true"
import script from "./addOrEdit.vue?vue&type=script&lang=js"
export * from "./addOrEdit.vue?vue&type=script&lang=js"
import style0 from "./addOrEdit.vue?vue&type=style&index=0&id=f77caff6&prod&lang=scss&scoped=true"
import style1 from "./addOrEdit.vue?vue&type=style&index=1&id=f77caff6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77caff6",
  null
  
)

export default component.exports